import styled from "styled-components";
import { RegisterContainer } from "../Register/styled";

export const LoginMain = styled.main`
  display: flex;
  justify-content: center;
`;

export const LoginContainer = styled(RegisterContainer)``;
